import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'checkout-default-bloc',
    standalone: true,
    imports: [],
    templateUrl: './default-bloc.component.html',
    styleUrl: './default-bloc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultBlocComponent {
    @Input() isMobile: boolean = false;
    @Input() suggestedProductLabel: boolean = false;
}
